import { useIntl } from '@leagueplatform/locales';
import {
  Icon,
  ParagraphText,
  StackLayout,
  UtilityText,
} from '@leagueplatform/genesis-core';

// Grey info banner explaining that mailed documents can't be turned off,
// rendered inside the document-delivery toggle group.
export const DisclaimerBanner = () => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout
      spacing="$half"
      horizontalAlignment="stretch"
      css={{
        // Figma: Input/Background Disabled (#E4E4E4).
        backgroundColor: '$inputBackgroundDisabled',
        borderRadius: '$small',
        padding: '$one',
      }}
    >
      <StackLayout
        orientation="horizontal"
        verticalAlignment="center"
        spacing="$half"
      >
        <Icon
          icon="interfaceQuestionCircleFilled"
          size="$one"
          tint="$onSurfaceIconPrimary"
        />
        <UtilityText
          css={{ typography: '$overline', color: '$onSurfaceTextPrimary' }}
        >
          {formatMessage({ id: 'STR_COMM_PREF_DISCLAIMER_TITLE' })}
        </UtilityText>
      </StackLayout>
      <ParagraphText css={{ typography: '$caption' }}>
        {formatMessage({ id: 'STR_COMM_PREF_DISCLAIMER_BODY' })}
      </ParagraphText>
    </StackLayout>
  );
};
